module.exports = __webpack_public_path__ + "components/weather-icon/static/dayheavysnow@2-954c469e131e6a88b6284b9c0ca6ca2e.png";